import React from 'react'

import { Form, Col } from '_zari/core'

import { TiposDocumentoSunatConstant } from 'constants/index'

const TipoDocumentoFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO DOCUMENTO' htmlFor='input-tipoDocumento' md={4} />
      <Col md={8}>
        <Form.Select value={value} onChange={onChange} id='input-tipoDocumento'>
          <option value=''>Seleccionar</option>
          {TiposDocumentoSunatConstant.__darDeBajaArray.map((x, k) => (
            <option key={k} value={x.id}>
              {x.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default TipoDocumentoFormGroup
